import { Navigate } from 'react-router-dom'
import KeycloakService from 'services/KeycloakService'

export default function RequireNonAuth({
  children,
}: {
  children: JSX.Element
}) {
  if (KeycloakService.isLoggedIn()) {
    return <Navigate to="/" replace={true} />
  }

  return children
}
